/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import CioConditionViewerBase, { CioConditionViewerBaseArgs } from 'cio/components/cio-condition-viewer-base';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { isNone } from '@ember/utils';
import GroupCondition, { all, any } from 'cio/app-models/conditions/group';
import FiltersService from 'cio/services/filters';
import { MainConditionInterface } from 'cio/app-models/conditions/abstract';
import ActionCondition from 'cio/app-models/conditions/action';
import AttributeCondition from 'cio/app-models/conditions/attribute';
import DeviceAttributeCondition from 'cio/app-models/conditions/device-attribute';
import { segmentViewComponent } from 'cio/utils/segment-view-component';

const GROUP_TYPES = {
  [all]: 'All',
  [any]: 'At least one',
};

interface CioConditionViewerGroupArgs extends CioConditionViewerBaseArgs {
  condition: GroupCondition;
  depth: number;
  labelTruncate?: boolean;
}

export default class CioConditionViewerGroup extends CioConditionViewerBase<CioConditionViewerGroupArgs> {
  @service filters!: FiltersService;

  @computed('args.condition.operator')
  get groupType() {
    return GROUP_TYPES[this.args.condition.operator];
  }

  @computed('args.condition.children.[]')
  get children() {
    let conditions = this.args.condition.children;

    if (isNone(conditions)) {
      return;
    }

    return conditions.map((condition: MainConditionInterface | ActionCondition | null) => {
      if (condition instanceof ActionCondition && this.filters.isBranchMessage(condition.action)) {
        condition.type = this.filters.branchMessageTypes[condition.action!];
      }

      return condition;
    });
  }

  @computed('args.condition.operator')
  get operatorClass() {
    let { operator } = this.args.condition;

    return `cio-condition-viewer-group--${operator}`;
  }

  get isTopLevelGroup() {
    return this.args.depth === 0;
  }

  segmentViewComponent(condition: AttributeCondition | DeviceAttributeCondition) {
    // avoid circular references
    if ((condition.uiType ?? condition.type) === 'group') {
      return CioConditionViewerGroup;
    }

    return segmentViewComponent([condition]);
  }
}
